var map = {
	".": "B7jJ",
	"./": "B7jJ",
	"./01_dept_info_interval": "bP1Q",
	"./01_dept_info_interval.json": "bP1Q",
	"./02_latest_records": "cRtg",
	"./02_latest_records.json": "cRtg",
	"./03_kline_data": "WbRb",
	"./03_kline_data.json": "WbRb",
	"./04_quote_ticker": "AAve",
	"./04_quote_ticker.json": "AAve",
	"./05_last_trade_price": "lqZR",
	"./05_last_trade_price.json": "lqZR",
	"./06_last_mark_price": "zVt3",
	"./06_last_mark_price.json": "zVt3",
	"./07_book_ticker": "5TRZ",
	"./07_book_ticker.json": "5TRZ",
	"./08_depth_incr_info": "PEl6",
	"./08_depth_incr_info.json": "PEl6",
	"./index": "B7jJ",
	"./index.js": "B7jJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9JvQ";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/swapV2/websocket/market ^.*$
// module id = 9JvQ
// module chunks = 3